export const shouldShowGoogleAdsContactUs = ({
  segmentSyncOff,
  adIntegrationOff,
  hasEcModule,
}: {
  segmentSyncOff: boolean;
  adIntegrationOff: boolean;
  hasEcModule: boolean;
}): boolean => segmentSyncOff && adIntegrationOff && !hasEcModule;

export const shouldShowMetaAdsContactUs = ({
  adIntegrationOff,
}: {
  adIntegrationOff: boolean;
}): boolean => adIntegrationOff;

/**
 * LINE Ads follows the Meta Ads rule: both only sync ad audiences, so both
 * depend on the ad integration entitlement alone.
 */
export const shouldShowLineAdsContactUs = ({
  adIntegrationOff,
}: {
  adIntegrationOff: boolean;
}): boolean => adIntegrationOff;
